import { useEffect, useRef, useState } from 'react';
import { AgnesButton, AgnesModal } from '@agnes/ui';
import { authStorage } from '@/lib/authStorage';
import ServiceAuthSSO from '@/services/ServiceAuthSSO';
import { usePermissionsStore } from '@/stores/usePermissionsStore';
import { verificarAlteracaoPerfil, type AlteracaoPerfil } from '@/utils/alteracaoPerfil';

const DATA_QA = 'aviso-alteracao-perfil';

export function AvisoAlteracaoPerfil() {
  const loaded = usePermissionsStore((s) => s.loaded);
  const verificado = useRef(false);
  const [alteracao, setAlteracao] = useState<AlteracaoPerfil | null>(null);

  // Espera as permissões: até lá o token pode ainda estar sendo renovado.
  useEffect(() => {
    if (!loaded || verificado.current) return;
    verificado.current = true;

    const token = authStorage.getItem('access_Token');
    const tenant = authStorage.getItem('tenant_slug');
    const usuarioId = token ? ServiceAuthSSO.getUserFromToken(token)?.id : null;
    if (!token || !tenant || !usuarioId) return;

    const resultado = verificarAlteracaoPerfil(
      tenant,
      usuarioId,
      ServiceAuthSSO.extractRolesFromToken(token),
    );
    if (resultado.alterado) setAlteracao(resultado);
  }, [loaded]);

  const fechar = () => setAlteracao(null);

  return (
    <AgnesModal
      open={alteracao !== null}
      title="Perfil alterado"
      maxWidth="xs"
      onClose={fechar}
      dataQa={DATA_QA}
      footer={
        <div className="flex justify-end">
          <AgnesButton variant="primary" data-qa={`${DATA_QA}-entendi`} onClick={fechar}>
            Entendi
          </AgnesButton>
        </div>
      }
    >
      {alteracao && (
        <p className="px-6 py-4 text-agnes-text-primary" data-qa={`${DATA_QA}-mensagem`}>
          {`Seu perfil foi alterado de "${alteracao.perfilDe}" para "${alteracao.perfilPara}" pelo administrador do sistema.`}
        </p>
      )}
    </AgnesModal>
  );
}
